import useSceneNavigator, { SceneRoutes } from '../../hooks/useSceneNavigator/useSceneNavigator';
import { useAuthContext } from '../../hooks/useAuth/useAuthContext';
import useSessionState from '../../hooks/useSessionState/useSessionState';
import { SessionStateKeys } from '../../models/session-state-keys';
import { FileToken } from '../../modules/lower-ui-kit/types/FileToken';

const useUploadSceneModel = () => {
  const { navigate } = useSceneNavigator();

  const [_, setUserCode] = useSessionState<string>({
    initialState: '',
    key: SessionStateKeys.UserCode,
  });

  const [uploadTokens, setUploadTokens] = useSessionState<FileToken[]>({
    initialState: [],
    key: SessionStateKeys.UploadTokens,
  });

  const { setIsAuthenticated } = useAuthContext();

  const onLogOut = () => {
    setUserCode('');
    setUploadTokens([]);
    setIsAuthenticated(false);
    navigate(SceneRoutes.ThankYouScene);
  };

  return {
    onLogOut,
    uploadTokens,
  };
};

export default useUploadSceneModel;
